(ns dashboard.components.expanding-textarea
  (:require [react]))

(defn expanding-textarea [{:keys [value default-value on-change] :as props}]
  (let [[ref set-ref] (react/useState nil)]
    (react/useEffect (fn []
                       ;; Simulate controlled textarea's value prop being changed. Controlling the value prop prevents undo/redo from working
                       (when (and ref
                                  (not= value (.-value ref))
                                  (not= default-value value))
                         (set! (.-value ref) (or value default-value)))
                       (cond
                         (and ref (empty? (or value default-value))) (set! (.. ref -style -height) "auto")
                         :else (when-let [scroll-height (some-> ref .-scrollHeight)]
                                 (set! (.. ref -style -height) (str scroll-height "px")))))
                     (array value default-value ref))
    [:textarea.textarea (merge (assoc-in (dissoc props :value) [:style :height] "0px")
                               {:ref set-ref
                                :on-change (fn [e]
                                             (when-let [scroll-height (some-> ref .-scrollHeight)]
                                               (set! (.. ref -style -height) (str scroll-height "px")))
                                             (on-change e))})]))
